import { useAuth } from '@/components/auth/authProvider';
import { isPalmettoFinanceUser } from '@/components/auth/RequirePalmettoFinanceUser';
import { Box, Card } from '@palmetto/palmetto-components';
import { useMemo } from 'react';

import { ProjectTransactionStatus, UserPermissions } from 'types';

import { FilterablePayoutTransactionTable } from '../FilterablePayoutTransactionTable';
import { PayoutTransactionTableColumnName } from '../PayoutTransactionTable';

export const UnbatchedTransactions = () => {
  const { claims } = useAuth();
  const isPalmettoFinanceReaderOrAdmin = useMemo(() => {
    return (
      isPalmettoFinanceUser(claims) &&
      (claims?.permissions?.includes(UserPermissions.lightReachAccountingAdmin) ||
        claims?.permissions?.includes(UserPermissions.lightReachAccountingReader))
    );
  }, [claims]);

  const hideColumns = useMemo(() => {
    const columns: PayoutTransactionTableColumnName[] = [
      'batch.batchDate',
      'projectExternalId',
      'status',
      'pauseExpirationDate',
    ];
    if (!isPalmettoFinanceReaderOrAdmin) {
      columns.push('tags');
    }
    return columns;
  }, [isPalmettoFinanceReaderOrAdmin]);
  return (
    <Card padding="sm" marginTop="0">
      <Card.Header>
        <Box direction="row" justifyContent="space-between" alignItems="center">
          <Box fontSize="xl" fontWeight="medium">
            Unbatched Transactions
          </Box>
        </Box>
      </Card.Header>
      <Box margin="0 lg 0 lg">
        <FilterablePayoutTransactionTable
          lockedQueryFilters={{
            status: ProjectTransactionStatus.open,
          }}
          hideColumns={hideColumns}
          hideFilters={[
            'eventDate',
            'status',
            'clawbackRuleName',
            'payoutHold',
            'projectExternalId',
            'isManual',
            'batchDate',
            'pauseExpirationDate',
            'pausedDueToPaymentPlan',
          ]}
          showPagination
          enabledButtons={['export', 'addTransaction', 'addToBatch']}
          hideSort={['pausedExpirationDateAsc', 'pausedExpirationDateDesc', 'batchDateAsc', 'batchDateDesc']}
        />
      </Box>
    </Card>
  );
};
